import React from 'react'
import { connect } from 'react-redux'
import { GATED_IN_TEXT_CITATION_MODAL } from '@chegg-wt/core/state/modals/constants'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { AppState } from '@chegg-wt/core/state'
import { modalDataSelector } from '@chegg-wt/core/state/modals/selectors'
import { navigated } from '@chegg-wt/core/state/app/actions'
import { GatedInTextCitationModalData } from '@chegg-wt/core/state/bibliography/types'
import { Config } from '@chegg-wt/core/config'
import { NOOP } from '@chegg-wt/core/constants/global'
import BaseGatedBibliographyModal from '../BaseGatedBibliographyModal'
import { GatedInTextCitationModalProps } from './types'

export const GatedInTextCitationModal: React.FC<GatedInTextCitationModalProps> = ({
  data,
  navigated,
}) => {
  const { toUpgrade } = useRoutesContext()
  const { isFootnote } = data
  const header = isFootnote ? 'Copy Footnote' : 'Copy In-Text Citation'
  const footnoteMessage = isFootnote ? 'copy footnotes' : 'copy in-text citations'
  const message = `Upgrade to ${Config.siteName} Plus to ${footnoteMessage}.`

  const onUpgrade: VoidFunction = () => {
    navigated(toUpgrade())
  }

  return (
    <BaseGatedBibliographyModal
      modalName={GATED_IN_TEXT_CITATION_MODAL}
      header={header}
      message={message}
      isDismissible
      onContinue={NOOP}
      onUpgrade={onUpgrade}
    />
  )
}

const mapStateToProps = (state: AppState) => ({
  data: modalDataSelector(state) as GatedInTextCitationModalData,
})

const mapDispatchToProps = {
  navigated,
}

export default connect(mapStateToProps, mapDispatchToProps)(GatedInTextCitationModal)
